export const LANGUAGE = {
  EN: 'en',
  ZH: 'zh'
};
